// extracted by mini-css-extract-plugin
export default {"dialog":"XoZJIVpGCzA6moAKTN-6TA==","searchBtn":"tEqbfjfgKEJ5JPjS82Caew==","dialogBody":"TgGeblgX0Q0rZnpIwK6fMA==","dialogFooter":"IyA-g6g9UWh7aJMiurAolQ=="};